module.exports = __webpack_public_path__ + "img/2.f2ff40e6.png";